import React from "react";
import "./styles.css";
/**
 * @function WidgetView 
 * @param {React.Component} children React components that's being wrapped by the WidgetView component.
 * @returns {React.Component}
 * @example
 * <WidgetView>
 *  <UpsellView icon={<SVGAsset id="someAsset"/>} text="Some text" />
 * </WidgetView>
 */
export default function WidgetView(props) {
  const className = props.className ?? "";

  return(
    <div className={`${className} row-container flex-height flex-container flex-horizontal wrap-items align-center biller-row`} onClick={ props.onClick }>
      {props.children}
    </div>
  );
}

export function WidgetMainContentView(props) {
  const className = props.className ?? "";

  return(
    <div className={ `flex-height flex-width flex-container flex-horizontal align-center row-main-content ${ className }` }>
      {props.children}
    </div>
  );
}
